import {SysConfigBaseApi} from "./SysConfigBaseApi";

/**
 * Api
 */
export class InforApi extends SysConfigBaseApi {
    public get ControllerName(): any {
        return 'Infor'
    }

    /**
     * 获取扩展类别
     * @param bucketName 
     */
    public getExts(bucketName: string) {
        return this.send({ bucketName: bucketName }, "GetExts", this.Methods.GET);
    }

    /**
     * 获取文件分享链接
     * @param tokenId 
     * @param effectiveTime 
     */
    public getShareLink(tokenId: string, effectiveTime: number) {
        return this.send({ tokenId: tokenId, effectiveTime: effectiveTime }, "GetShareLink", this.Methods.GET);
    }

    /**
     * 根据GroupName 和 Token 获取文件列表
     * @param token 
     * @param groupName 
     */
    public getFilesByGroupName(token: string, groupName: string) {
        return this.send({ token, groupName }, "GetFilesByGroupName", this.Methods.GET);
    }

    /**
     * 根据Token 获取文件列表
     * @param token 
     */
     public GetFilesByToken(token: any []) {
        return this.send({ tokens:token }, "GetFilesByToken", this.Methods.POST);
    }

    /**
     * 获取附件信息
     * @param token 
     */
     public GetFileListByTokens(token: string) {
        return this.send({ Tokens:token }, "GetFileListByTokens", this.Methods.POST);
    }

     /**
     * 获取附件信息
     * @param token 
     */
      public GetFilePageListByTokens(pageIndex:number,pageSize:number,token: string,orderBy: string) {
        return this.send({ pageIndex:pageIndex,pageSize:pageSize,Tokens:token,orderBy:orderBy }, "GetFilePageListByTokens", this.Methods.POST);
    }
}
